import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Controls the file upload preview for single image uploads
export default class extends Controller {
  static targets = ["input", "preview", "dropZone"]

  connect() {
    // Initialize
  }

  // Handle file selection via click
  preview() {
    this.updatePreview(this.inputTarget.files[0])
  }

  // Handle drag over
  dragOver(e) {
    e.preventDefault()
    this.dropZoneTarget.classList.add("border-primary", "bg-primary/5")
  }

  // Handle drag leave
  dragLeave(e) {
    e.preventDefault()
    this.dropZoneTarget.classList.remove("border-primary", "bg-primary/5")
  }

  // Handle drop
  drop(e) {
    e.preventDefault()
    this.dropZoneTarget.classList.remove("border-primary", "bg-primary/5")
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      this.inputTarget.files = e.dataTransfer.files
      this.updatePreview(e.dataTransfer.files[0])
    }
  }

  updatePreview(file) {
    if (!file) return

    // Ensure it's an image
    if (!file.type.match('image.*')) {
      alert(t('javascript.controllers.image_upload_controller.please_upload_an_image_file'))
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.innerHTML = `
        <div class="flex flex-col items-center justify-center pt-4 pb-5 w-full">
          <div class="relative group">
            <img src="${e.target.result}" class="h-20 w-auto object-contain mb-2 rounded-lg border border-gray-200 bg-white p-1" />
            <div class="absolute -right-2 -top-2 bg-green-500 text-white rounded-full p-0.5">
              <span class="material-symbols-outlined !text-sm">check</span>
            </div>
          </div>
          <p class="mb-1 text-sm text-gray-900 font-medium truncate max-w-[200px]">${file.name}</p>
          <p class="text-xs text-green-600 font-medium">${t("javascript.controllers.image_upload_controller.ready_to_save")}</p>
        </div>
      `
    }
    reader.readAsDataURL(file)
  }
}
